// Module
var code = `<div
  id="@id@"
  ng-controller="FormViewCtrl as fc"
>
  <!-- Note 1: JSON Forms does not fallback to automatic schema / ui schema generation
  when an empty value occurs, so we have to omit the related attribute manually
  when the related data is empty; hence the ugliness below: -->

  <jsonforms
    ng-if="fc.schema && fc.uischema"
    schema="fc.schema"
    uischema="fc.uischema"
    data="fc.data"
  ></jsonforms>

  <jsonforms
    ng-if="fc.schema && !fc.uischema"
    schema="fc.schema"
    data="fc.data"
  ></jsonforms>

  <jsonforms
    ng-if="!fc.schema && fc.uischema"
    uischema="fc.uischema"
    data="fc.data"
  ></jsonforms>

  <jsonforms
    ng-if="!fc.schema && !fc.uischema"
    data="fc.data"
  ></jsonforms>

  <p>
    <div ng-repeat="act in fc.actions"
         class="btn btn-primary me-2 menu-item-content add-property"
         ng-attr-aria-label="act.props.label"
         ng-click="fc.submit(act.name)"
    >
      <i ng-show="act.props.icon" ng-class="'fa fa-' + act.props.icon"></i>
      {{act.props.label}}
    </div>
  </p>
</div>
`;
// Exports
export default code;